import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';
import { useUserStore } from '../../stores/userStore';
import { trackReviewContentClick } from '../../lib/gaEvents';
import { CONTENT_TYPE, REVIEW_SECTION } from '../../constants/gaEnums';
import AlbumCover from '../common/AlbumCover';
import AlbumTitleLink from '../common/AlbumTitleLink';
import theme from '../../theme';

const AlbumHorizontalSimpleCard = ({
  albumId,
  sourceId,
  albumSource,
  slug,
  imageUrl,
  albumName,
  contentRating = 'CLEAN',
  releaseDate,
  artist = null,
  imageSize = 40,
  referrerSection,
}) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();
  const user = useUserStore((state) => state.user);
  const albumUrl = slug
    ? albumId
      ? `/reviews/${slug}`
      : `/reviews/${slug}?source_id=${sourceId}`
    : `/reviews/${albumSource.toLowerCase()}/${sourceId}`;
  const albumLinkState = {
    sourceId,
    sourceType: albumSource,
    ...(referrerSection && { referrerSection }),
  };

  const handleOnClick = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      if (referrerSection === REVIEW_SECTION.ISSUES) {
        trackReviewContentClick(
          {
            section: REVIEW_SECTION.ISSUES,
            contentType: CONTENT_TYPE.ALBUM,
            contentId: sourceId,
            contentName: albumName,
          },
          user,
        );
      }
      navigateWithScrollMemory(albumUrl, { state: albumLinkState });
    }
  };

  return (
    <Box
      component={Link}
      to={albumUrl}
      state={albumLinkState}
      onClick={handleOnClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        maxWidth: 380,
        width: '100%',
        padding: '12px 16px',
        textDecoration: 'none',
        color: 'inherit',
        cursor: 'pointer',
      }}
    >
      <Box sx={{ width: imageSize, height: imageSize, flexShrink: 0 }}>
        <AlbumCover
          imageUrl={imageUrl}
          altText={albumName}
          sx={{ width: '100%', aspectRatio: '1 / 1', objectFit: 'cover' }}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <AlbumTitleLink
          title={albumName}
          contentRating={contentRating}
          sx={{ fontSize: { xs: 13, md: 13 }, fontWeight: 'bold', lineHeight: 'normal' }}
          iconSx={{ width: '12px', height: '12px' }}
        />
        {artist && (
          <Typography
            fontSize={12}
            color={theme.palette.black[4]}
            sx={{ lineHeight: 'normal', mt: '8px' }}
          >
            {artist.name}
          </Typography>
        )}
        {releaseDate && (
          <Typography
            fontSize={12}
            color={theme.palette.black[2]}
            noWrap
            sx={{ lineHeight: 'normal', mt: '10px' }}
          >
            {releaseDate?.replaceAll('-', '.')}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AlbumHorizontalSimpleCard;
